import { useId, type InputHTMLAttributes } from 'react';

interface ProprietesChamp extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  erreur?: string;
  aide?: string;
  /** Aligne à droite en chasse fixe : tout montant passe par là. */
  montant?: boolean;
}

/**
 * Champ de formulaire (charte, doc 06, § 6.2).
 *
 * Le label est au-dessus, jamais flottant : un label flottant disparaît
 * dès que le champ est rempli, ce qui rend la relecture d'un formulaire
 * de saisie impossible.
 */
export function Champ({ label, erreur, aide, montant, ...proprietes }: ProprietesChamp) {
  const id = useId();
  const idMessage = `${id}-message`;

  return (
    <div className={`champ${montant ? ' champ--montant' : ''}${erreur ? ' champ--erreur' : ''}`}>
      <label className="surtitre" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        aria-invalid={erreur ? true : undefined}
        aria-describedby={erreur || aide ? idMessage : undefined}
        {...proprietes}
      />
      {erreur ? (
        <span className="champ__message" id={idMessage}>
          {erreur}
        </span>
      ) : aide ? (
        <span className="champ__aide" id={idMessage}>
          {aide}
        </span>
      ) : null}
    </div>
  );
}
